export function tabs() {
    const tabs = [...document.querySelectorAll('.tabs-title')];

    tabs.forEach((el) => {
        el.addEventListener('click', e => {
            let tab = e.target;

            if (tab.matches('.active')) return;

            let wrapper = tab.closest('.tabs'),
                index = Array.from(tab.parentNode.children).indexOf(tab),
                tabContent = wrapper.querySelectorAll('.tabs-content')[index];

            wrapper.querySelectorAll('.active').forEach(e => {
                e.classList.remove('active')
            });

            tab.classList.add('active');
            tabContent.classList.add('active');

            tabContent.querySelectorAll('div').forEach((e, i) => {
                setTimeout(() => {
                    e.classList.add('active');
                }, i * 50)
            });
        });
    });
}
